module.exports = __webpack_public_path__ + "static/home_galeria_1-7980f8eb8a28893934c8c80a10d82c03.jpg";